"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkmark = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Checkmark = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M20.843 7.62L9.617 18.597a.535.535 0 01-.752 0l-5.708-5.582a.512.512 0 010-.735l.741-.725a.535.535 0 01.752 0l4.586 4.484 10.114-9.89a.549.549 0 01.752 0l.741.735a.512.512 0 010 .736z" })); };
exports.Checkmark = Checkmark;
//# sourceMappingURL=checkmark.js.map